import { IStorage } from './interfaces';

export default class MemoryStorage implements IStorage {
    private readonly cache: Map<string, string> = new Map();

    public getItem(key: string): string {
        return this.cache.get(key);
    }

    public setItem(key: string, value: string): void {
        this.cache.set(key, value);
    }

    public removeItem(key: string): void {
        this.cache.delete(key);
    }

    public clear(): void {
        this.cache.clear();
    }
}
